module.exports = __webpack_public_path__ + "static/media/water-lower.b7922013.svg";